import { render, staticRenderFns } from "./GegevensWijzigen.vue?vue&type=template&id=2f31deef&"
import script from "./GegevensWijzigen.vue?vue&type=script&lang=js&"
export * from "./GegevensWijzigen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/dev/tafelgasten.outlawz.dev/web/app/themes/expert/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f31deef')) {
      api.createRecord('2f31deef', component.options)
    } else {
      api.reload('2f31deef', component.options)
    }
    module.hot.accept("./GegevensWijzigen.vue?vue&type=template&id=2f31deef&", function () {
      api.rerender('2f31deef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/scripts/vue/MijnAccount/GegevensWijzigen.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/MijnAccount/GegevensWijzigen.vue
// module id = 428
// module chunks = 0